import { Counter } from '../Faces';
import { Original } from '../Themes';
import { English } from '../Languages';

/**
 * @alias DefaultValues
 * @type {object}
 * @memberof module:Config/DefaultValues
 */
export default {
    face: Counter,
    theme: Original,
    language: English
};
